/**
 * Convert absolute internal Capsule CRM links to relative links
 * @param {string} link - The input link to convert
 * @returns {string} The converted relative link or "/" if empty
 */
const convertCapsuleLink = link => {
  if (!link) return ""

  // Don't treat asset links as pages (use normal anchor tags)
  if (link.startsWith("https://capsulecrm.com/assets/")) {
    return link
  }

  const convertedLink = link.replace(/^https:\/\/capsulecrm\.com/, "")
  return convertedLink || "/"
}

export default convertCapsuleLink
